export default __webpack_public_path__ + "static/media/4-2-chair-png 2.9cb8a86a.png";